export default "__VITE_ASSET__BtTXnrfr__"